<script lang="ts">
	import hero1Mobile from "@assets/images/hero/1.png?format=webp&w=384&imagetools";
	import hero1Desktop from "@assets/images/hero/1.png?format=webp&w=1200&imagetools";
	import hero2Mobile from "@assets/images/hero/2.png?format=webp&w=216&imagetools";
	import hero2Desktop from "@assets/images/hero/2.png?format=webp&w=1440&imagetools";
	import hero3Mobile from "@assets/images/hero/3.png?format=webp&w=256&imagetools";
	import hero3Desktop from "@assets/images/hero/3.png?format=webp&w=1200&imagetools";
	import hero4Mobile from "@assets/images/hero/4.png?format=webp&w=192&imagetools";
	import hero4Desktop from "@assets/images/hero/4.png?format=webp&w=1680&imagetools";
	import calendarIcon from "@core/assets/icons/calendar.svg?raw";
	import couchIcon from "@core/assets/icons/couch.svg?raw";
	import Formatted from "../common/Formatted.svelte";
	import Link from "../common/Link.svelte";
	import Media from "../common/Media.svelte";
	import { ButtonVariant } from "../common/getButtonClass.js";
</script>

<section class="relative full-width overflow-x-clip w-full !py-0 md:!py-16 [@media(max-height:700px)]:!py-4">
	<div
		class="relative w-full 2xl:w-[90rem] md:h-[45rem] h-[528px] [@media(max-height:700px)]:h-[400px] [@media(max-height:700px)]:md:h-[36rem] mx-auto"
	>
		<div
			class="absolute w-[7.75rem] h-[5.5rem] md:w-[20%] md:h-[25%] xl:left-[12rem] xl:-top-[10rem] xl:w-[18.75rem] xl:h-[12.5rem] left-8 -top-6 md:left-[12rem] md:-top-[10rem] [@media(max-height:700px)]:w-[6rem] [@media(max-height:700px)]:h-[4rem] [@media(max-height:700px)]:md:w-[14rem] [@media(max-height:700px)]:md:h-[9rem] [@media(max-height:700px)]:xl:w-[14rem] [@media(max-height:700px)]:xl:h-[9rem]"
		>
			<Media
				source={{ src: hero2Desktop, type: "image" }}
				sourcesets={{
					"<md": hero2Mobile,
					">md": hero2Desktop,
				}}
				preload={{ fetchpriority: "high" }}
				alt="Head Spa relaxační procedura"
				width={300}
				height={200}
				class="w-full h-full object-cover bg-ivory-100 shadow-[0rem_1.5rem_1rem_-1rem_rgba(0,0,0,0.2)] rounded-[4rem]"
				eager
			/>
		</div>

		<div
			class="absolute w-[8rem] h-[12rem] md:w-[22.5%] md:h-[33.75%] xl:left-[72.5rem] xl:top-[1.25rem] xl:w-[22.5rem] xl:h-[33.75rem] -right-10 top-16 md:-right-[2.5rem] md:top-[1.25rem] [@media(max-height:700px)]:w-[6rem] [@media(max-height:700px)]:h-[9rem] [@media(max-height:700px)]:md:w-[16rem] [@media(max-height:700px)]:md:h-[24rem] [@media(max-height:700px)]:xl:w-[16rem] [@media(max-height:700px)]:xl:h-[24rem]"
		>
			<Media
				source={{ src: hero3Desktop, type: "image" }}
				sourcesets={{
					"<md": hero3Mobile,
					">md": hero3Desktop,
				}}
				alt="Head Spa masáž hlavy"
				preload={{ fetchpriority: "high" }}
				width={360}
				height={540}
				class="w-full h-full object-cover bg-ivy-100 shadow-[0rem_3rem_2.5rem_-1rem_rgba(0,0,0,0.25)] rounded-[4rem]"
				eager
			/>
		</div>

		<div
			class="absolute w-[6rem] h-[9rem] md:w-[18.75%] md:h-[45.125%] xl:-left-4 xl:top-[16rem] xl:w-[18.75rem] xl:h-[28.125rem] -left-8 top-[16rem] md:-left-12 md:top-[16rem] [@media(max-height:700px)]:w-[5rem] [@media(max-height:700px)]:h-[7.5rem] [@media(max-height:700px)]:md:w-[14rem] [@media(max-height:700px)]:md:h-[21rem] [@media(max-height:700px)]:xl:w-[14rem] [@media(max-height:700px)]:xl:h-[21rem]"
		>
			<Media
				source={{ src: hero4Desktop, type: "image" }}
				sourcesets={{
					"<md": hero4Mobile,
					">md": hero4Desktop,
				}}
				preload={{ fetchpriority: "high" }}
				alt="Head Spa péče o vlasy"
				width={300}
				height={450}
				class="w-full h-full object-cover bg-ivory-100 shadow-[0rem_2.5rem_2rem_-1rem_rgba(0,0,0,0.25)] rounded-[4rem]"
				eager
			/>
		</div>

		<div
			class="absolute w-[12rem] h-[8rem] md:w-[26.25%] md:h-[27.5%] xl:left-[42.5rem] xl:top-[31.875rem] xl:w-[26.25rem] xl:h-[17.5rem] left-[20rem] -translate-x-1/2 bottom-0 md:bottom-auto md:left-[42.5rem] md:top-[31.875rem] md:translate-x-0 [@media(max-height:700px)]:w-[10rem] [@media(max-height:700px)]:h-[6.5rem] [@media(max-height:700px)]:md:w-[20rem] [@media(max-height:700px)]:md:h-[13rem] [@media(max-height:700px)]:xl:w-[20rem] [@media(max-height:700px)]:xl:h-[13rem]"
		>
			<Media
				source={{ src: hero1Desktop, type: "image" }}
				sourcesets={{
					"<md": hero1Mobile,
					">md": hero1Desktop,
				}}
				preload={{ fetchpriority: "high" }}
				alt="Head Spa relaxace"
				width={420}
				height={280}
				class="w-full h-full object-cover bg-ivory-100 shadow-[0rem_2rem_1.5rem_-1rem_rgba(0,0,0,0.2)] rounded-[4rem]"
				eager
			/>
		</div>

		<div
			class="absolute left-1/2 md:top-1/2 -translate-x-1/2 md:-translate-y-1/2 flex flex-col items-center top-[81px] gap-8 md:gap-16 [@media(max-height:700px)]:gap-4 [@media(max-height:700px)]:md:gap-8 z-10 w-[234px] sm:w-[64rem]"
		>
			<div class="flex flex-col items-center gap-[.8438rem] md:gap-[1.6875rem] w-full md:w-[50rem]">
				<h1 class="w-full text-center sm:inline-block hidden">
					<Formatted text="Zažij Head Spa" /><br />
					<span class="inline-block">
						<Formatted text="v Karviné" />
						<span class="relative inline-block">
							napohodu
							<span class="absolute bottom-0 left-0 h-1 w-full bg-current"></span>
						</span>
					</span>
				</h1>
				<h1 class="w-full text-center sm:hidden inline-block">
					<Formatted text="Zažijnl[[]]Head Spa nl[[]] v Karviné" />
					<span class="relative inline-block">
						napohodu
						<span class="absolute bottom-0 left-0 h-0.5 w-full bg-current"></span>
					</span>
				</h1>
				<p class="xl:w-[50rem] sm:w-[30rem] w-[234px] text-center">
					<Formatted
						text="Nech zastavit čas, vypni hlavu.nl[[]]Dopřej si klid, masáže a péči o pokožku i vlasy v jedné proceduře"
					/>
				</p>
			</div>
			<div class="flex md:gap-4 gap-2 sm:flex-row flex-col justify-center items-center">
				<Link
					href="https://head-spa-na-pohodu.reservio.com/"
					target="_blank"
					variant={ButtonVariant.PrimaryMedium}
					iconStart={calendarIcon}>rezervovat termín</Link
				>
				<Link href="/procedury" variant={ButtonVariant.SecondaryMedium} iconStart={couchIcon}>vybrat proceduru</Link>
			</div>
		</div>
	</div>
</section>
